import { Toaster } from 'react-hot-toast';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ErrorProvider } from './contexts/ErrorContext';
import { SuccessProvider } from './contexts/SuccessContext';
import { ThemeProvider } from './contexts/ThemeContext';

import AdminPanel from './components/AdminPanel';
import GameBoard from './components/GameBoard';
import Lobby from './components/Lobby';
import { LobbyWaiting } from './components/LobbyWaiting';
import Home from './components/Home';
import AdminRoute from './components/AdminRoute';
import AdminLogin from './components/AdminLogin';
import './index.css';

// Wrapper-Komponente für die Error-Anzeige
function AppContent() {
  const { error, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Lade...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
        <div className="max-w-md w-full bg-red-50 border border-red-200 rounded-lg p-6">
          <h2 className="text-lg font-semibold text-red-800 mb-2">Authentifizierungsfehler</h2>
          <p className="text-red-600">{error}</p>
          <button 
            onClick={() => window.location.reload()} 
            className="mt-4 btn btn-secondary"
          >
            Seite neu laden
          </button>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/lobby" element={<Lobby />} />
      <Route path="/lobby/:lobbyId" element={<LobbyWaiting />} />
      <Route path="/game/:lobbyId" element={<GameBoard />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminRoute />}>
        <Route index element={<AdminPanel />} />
      </Route>
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <ErrorProvider>
        <SuccessProvider>
          <ThemeProvider>
            <main>
              <div className="noise-overlay"></div>
              <div className="content">
                <Toaster
                  position="top-center"
                  reverseOrder={false}
                  toastOptions={{
                    duration: 5000,
                    style: {
                      background: '#333',
                      color: '#fff',
                    },
                  }}
                />
                <Router>
                  <AppContent />
                </Router>
              </div>
            </main>
          </ThemeProvider>
        </SuccessProvider>
      </ErrorProvider>
    </AuthProvider>
  );
}

export default App;
